// @flow
import React from 'react';
import { CheckBoxField } from '@src/formik-utils/FormFields';
import { ESTIMATE_COMMIT_DETAILS_CONFIG_MAP } from '@src/configuration/estimate-commit-details';

export const EstimateCommitMSKTakeoutContainer = () => {
  const MSK_TAKEOUT = 'msk_takeout';
  const { backendFieldName, displayName } = ESTIMATE_COMMIT_DETAILS_CONFIG_MAP.get(MSK_TAKEOUT);

  return (
    <CheckBoxField
      displayCheckBoxBelowLabel={true}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
    />
  );
};
